import {PageTitles} from 'shared/PageHelmet/types';

export const getPageTitle = (key: PageTitles, identifier?: string) => `${key}${identifier ? ` | ${identifier}` : ''}`;
